import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getServiceRequestInfo,
  servieRequestSubmit,
  getServiceRequestDraft,
} from "api/serviceAPI";
import { resetStates } from "./serviceCardSlice";
import axios from "axios";
import moment from "moment";

export const fetchServiceRequestInfo = createAsyncThunk(
  "serviceRequest/ServiceRequestInfo",
  async (param, { signal }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener("abort", () => {
      source.cancel();
    });
    const response = await getServiceRequestInfo(param, {
      cancelToken: source.token,
    });
    return response;
  }
);
export const fetchServiceRequestDraft = createAsyncThunk(
  "serviceRequest/ServiceRequestDraft",
  async (param, { signal }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener("abort", () => {
      source.cancel();
    });
    const response = await getServiceRequestDraft(param, {
      cancelToken: source.token,
    });
    return response;
  }
);

export const SubmitServieRequest = createAsyncThunk(
  "serviceRequest/SubmitServieRequest",
  async (param, { signal }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener("abort", () => {
      source.cancel();
    });
    const response = await servieRequestSubmit(param, {
      cancelToken: source.token,
    });
    return response;
  }
);

const slice = createSlice({
  name: "serviceRequest",
  initialState: {
    loading: "idle",
    inputsData: null,
    inputsDataValue: [],
    attachmentsData: null,
    attachmentsDataValue: [],
    serviceData: null,
    requestDate: null,
    requestId: null,
    error: null,
  },
  reducers: {
    setError: (state, { payload }) => {
      state.error = payload;
    },
    resetRequest: (state) => {
      state.loading = "idle";
      state.inputsData = null;
      state.attachmentsData = null;
      state.serviceData = null;
      state.requestDate = null;
      state.requestId = null;
      state.inputsDataValue = [];
      state.attachmentsDataValue = [];
      state.error = null;
    },
  },
  extraReducers: {
    [fetchServiceRequestInfo.pending]: (state) => {
      if (state.loading === "idle") {
        state.loading = "pending";
      }
    },
    [fetchServiceRequestInfo.fulfilled]: (state, { payload }) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        if (payload?.Status) {
          state.serviceData = payload?.Data?.Service_Data;
          state.inputsData = payload?.Data?.Inputs_Data;
          state.attachmentsData = payload?.Data?.Attachments_Data;
          state.requestDate = moment(
            payload?.Data?.Request_Data.Request_Draft_Date
          ).format("YYYY-MM-DD");
          state.requestId = payload?.Data?.Request_Data.Request_Draft_Id;
        }
      }
    },
    [fetchServiceRequestInfo.rejected]: (state, action) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        state.error = action.error;
      }
    },
    [fetchServiceRequestDraft.pending]: (state) => {
      if (state.loading === "idle") {
        state.loading = "pending";
      }
    },
    [fetchServiceRequestDraft.fulfilled]: (state, { payload }) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        if (payload?.Status) {
          state.serviceData = payload?.Data?.Service_Data;
          state.inputsData = payload?.Data?.Inputs_Data;
          state.attachmentsData = payload?.Data?.Attachments_Data;
          state.requestDate = moment(
            payload?.Data?.Request_Data.Request_Draft_Date
          ).format("YYYY-MM-DD");
          state.requestId = payload?.Data?.Request_Data.Request_Draft_Id;
          state.inputsDataValue = payload?.Data?.Inputs_Data_Values;
          state.attachmentsDataValue = payload?.Data?.Attachments_Data_Values;
        }
      }
    },
    [fetchServiceRequestDraft.rejected]: (state, action) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        state.error = action.error;
      }
    },
    [SubmitServieRequest.pending]: (state) => {
      if (state.loading === "idle") {
        state.loading = "pending";
      }
    },
    [SubmitServieRequest.fulfilled]: (state, { payload }) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        if (payload?.Status) {
          state.serviceData = payload?.Data?.Service_Data;
          state.inputsData = payload?.Data?.Inputs_Data;
          state.attachmentsData = payload?.Data?.Attachments_Data;
          state.requestDate = moment(
            payload?.Data?.Request_Data.Request_Draft_Date
          )
            .lang("en")
            .format("YYYY-MM-DD");
          state.requestId = payload?.Data?.Request_Data.Request_Draft_Id;
        }
      }
    },
    [SubmitServieRequest.rejected]: (state, action) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        state.error = action.error;
      }
    },
    [resetStates]: (state) => {
      state.loading = "idle";
      state.serviceData = null;
      state.inputsData = null;
      state.attachmentsData = null;
      state.requestDate = null;
      state.requestId = null;
      state.error = null;
    },
  },
});
export default slice.reducer;

export const { setError, resetRequest } = slice.actions;
